import { useEffect } from 'react'
import BottomSheetContent from './BottomSheetContent'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import { PowerOfRebalancingPointer } from '../elite/landing-page/versions/landing-page-pointers/PowerOfRebalancingPointer'
import { PowerRankPointerV2 } from '../elite/landing-page/versions/landing-page-pointers/PowerRankPointerV2 copy'
import { RankTrendsPointer } from '../elite/landing-page/versions/landing-page-pointers/RankTrendsPointer'
import type { EliteEventExtras } from '../../utils/eliteEventExtras'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
  // Passed by the in-page opener; this sheet is in a portal and cannot read context.
  buyCtaExtras?: EliteEventExtras
}

export const ViewAllBenefitsBottomSheet = ({ onDismiss, ScreenName, buyCtaExtras = {} }: BottomSheetWrapperPropTypes) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'PoweUp Elite',
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent onDismiss={onDismiss} bottomSheetHeadClassName='!pt-0' bottomSheetBodyClassName='!px-0'>
      <div className='rounded-t-xl bg-white pt-8 pb-1 relative z-0 overflow-hidden'>
        <div className='absolute top-0 w-full z-[-1] mt-[-40px]'>
          <img
            src='/images/elite/elite_benefits_lines.svg'
            alt=''
            aria-hidden='true'
            className='w-full h-auto'
          />
        </div>
        <div className='px-5'>
          <h2 className='text-[22px] font-[500] leading-[140%] m-0'>
            <span className='text-[#CC5C2D]'>What you get with </span>
            <span className='text-black'>Elite?</span>
          </h2>
        </div>
        <ul className='list-none m-0 p-0'>
          <li className='pt-8 px-5 pb-5 list-none'>
            <PowerRankPointerV2 buyCtaExtras={buyCtaExtras} />
          </li>
          <li className='pt-8 px-5 pb-5 list-none border-t'>
            <RankTrendsPointer />
          </li>
          <li className='pt-8 px-5 pb-5 list-none border-t'>
            <PowerOfRebalancingPointer />
          </li>
        </ul>
      </div>
    </BottomSheetContent>
  )
}

